import { Icon, type TreeMapNode, TreeMapNodeState, TreeMapNodeType } from '@graftcode/design-system'

import type { HostedModule } from '../../../modules/gateways/types/gateway.type'

export function buildHostedModuleNode(gatewayId: string, module: HostedModule): TreeMapNode {
  return {
    id: `${gatewayId}::service::${module.name}`,
    label: module.name,
    type: TreeMapNodeType.Service,
    icon: Icon.DSService,
    state: TreeMapNodeState.Active,
    metadata: {
      gatewayId,
      version: module.version,
      feedProtocol: module.feedProtocol,
      feedType: module.feedType,
      description: module.description,
    },
  }
}
